import React from 'react';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';

const DISPLAY_OPTIONS = ['block', 'flex', 'grid', 'inline', 'inline-flex', 'none'];

const Row = ({ label, children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
    <Typography variant="caption" sx={{ color: '#888', fontSize: 11, width: 56, flexShrink: 0 }}>
      {label}
    </Typography>
    {children}
  </Box>
);

const LayoutPanel = ({ styles = {}, onChange }) => {
  const get = (prop, fallback = '') => styles[prop] || fallback;
  const isFlex = get('display', 'block').includes('flex');

  return (
    <Box>
      <Row label="Display">
        <Select
          size="small"
          value={get('display', 'block')}
          onChange={(e) => onChange('display', e.target.value)}
          sx={{ fontSize: 12, flex: 1, '& .MuiSelect-select': { py: 0.5 } }}
        >
          {DISPLAY_OPTIONS.map((d) => (
            <MenuItem key={d} value={d} sx={{ fontSize: 12 }}>{d}</MenuItem>
          ))}
        </Select>
      </Row>

      {isFlex && (
        <>
          <Row label="Direction">
            <ToggleButtonGroup
              size="small"
              exclusive
              value={get('flexDirection', 'row')}
              onChange={(_, v) => v && onChange('flexDirection', v)}
            >
              {['row', 'column'].map((d) => (
                <ToggleButton key={d} value={d} sx={{ fontSize: 10, px: 1, py: 0.5, textTransform: 'none' }}>
                  {d}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Row>

          <Row label="Justify">
            <Select
              size="small"
              value={get('justifyContent', 'flex-start')}
              onChange={(e) => onChange('justifyContent', e.target.value)}
              sx={{ fontSize: 12, flex: 1, '& .MuiSelect-select': { py: 0.5 } }}
            >
              {['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'].map((v) => (
                <MenuItem key={v} value={v} sx={{ fontSize: 12 }}>{v}</MenuItem>
              ))}
            </Select>
          </Row>

          <Row label="Align">
            <Select
              size="small"
              value={get('alignItems', 'stretch')}
              onChange={(e) => onChange('alignItems', e.target.value)}
              sx={{ fontSize: 12, flex: 1, '& .MuiSelect-select': { py: 0.5 } }}
            >
              {['stretch', 'flex-start', 'center', 'flex-end', 'baseline'].map((v) => (
                <MenuItem key={v} value={v} sx={{ fontSize: 12 }}>{v}</MenuItem>
              ))}
            </Select>
          </Row>

          <Row label="Gap">
            <TextField
              size="small"
              type="number"
              value={parseFloat(get('gap', '0px')) || 0}
              onChange={(e) => onChange('gap', e.target.value + 'px')}
              inputProps={{ min: 0, style: { fontSize: 12, padding: '3px 6px', width: 52 } }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1 } }}
            />
          </Row>

          <Row label="Wrap">
            <ToggleButtonGroup
              size="small"
              exclusive
              value={get('flexWrap', 'nowrap')}
              onChange={(_, v) => v && onChange('flexWrap', v)}
            >
              {['nowrap', 'wrap'].map((w) => (
                <ToggleButton key={w} value={w} sx={{ fontSize: 10, px: 1, py: 0.5, textTransform: 'none' }}>
                  {w}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Row>
        </>
      )}
    </Box>
  );
};

export default LayoutPanel;
